<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h3>{{ $t("SalonProvider.showsubScriptions") }}</h3>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <!-- Start:: Item Image -->
        <template v-slot:[`item.id`]="{ index }">
          <div class="table_image_wrapper">
            <p>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>
        <!-- End:: Item Image -->

        <!-- Start:: Item Image -->
        <template v-slot:[`item.package_image`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.package_image">
              {{ $t("TABLES.noData") }}
            </h6>

            <button class="my-1" @click="showImageModal(item)" v-else>
              <!-- <video
                v-if="item.package_image.endsWith('mp4')"
                :src="item.package_image"
                width="80"
                height="60"
                class="rounded"
              ></video> -->
              <img
                class="rounded"
                :src="item.package_image"
                width="60"
                height="60"
              />
            </button>
          </div>
        </template>
        <!-- End:: Item Image -->
        <!-- Start:: Subscriptions Status -->
        <template v-slot:[`item.subscription_status`]="{ item }">
          <span
            class="text-success fs-6"
            v-if="item.subscription_status === 'active'"
          >
            <span>{{ $t("PLACEHOLDERS.sub_active") }}</span>
          </span>
          <span class="text-danger fs-6" v-else>
            <span>{{ $t("PLACEHOLDERS.sub_inactive") }}</span>
          </span>
        </template>
        <!-- End:: Subscriptions Status -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <!-- // PDF Icon -->
            <a-tooltip
              placement="bottom"
              v-if="item.order_status !== 'canceled'"
            >
              <template slot="title">
                <span>{{ $t("PLACEHOLDERS.pdf") }}</span>
              </template>
              <button class="btn_show" @click="downloadPdf(item)">
                <i class="fas fa-file-pdf"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->
        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Image Modal -->
          <image-modal
            v-if="dialogImage"
            :type="selectedItemType"
            :modalIsOpen="dialogImage"
            :modalImage="selectedItemImage"
            @toggleModal="dialogImage = !dialogImage"
          />
          <!-- End:: Image Modal -->

          <!-- Start:: Description Modal -->
          <!-- <description-modal
            v-if="dialogDescription"
            :modalIsOpen="dialogDescription"
            :modalDesc="selectedDescriptionTextToShow"
            @toggleModal="dialogDescription = !dialogDescription"
          /> -->
          <!-- End:: Description Modal -->

          <!-- Start:: Delete Modal -->
          <!-- <v-dialog v-model="dialogDelete">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToDelete">
                {{
                  $t("TITLES.DeleteConfirmingMessage", {
                    name: itemToDelete.name,
                  })
                }}
              </v-card-title>
              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="confirmDeleteItem">{{
                  $t("BUTTONS.ok")
                }}</v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogDelete = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
          <!-- End:: Delete Modal -->
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AllRegions",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
    subscriptions() {
      return [
        {
          id: null,
          name: this.$t("SalonProvider.subscribed"),
          value: 1,
        },
        {
          id: 1,
          name: this.$t("SalonProvider.notSubscribed"),
          value: 0,
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      dialogImage: false,
      // End:: Loading Data
      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.package_name"),
          value: "package_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.image"),
          value: "package_image",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("SalonProvider.subscription_fee"),
          value: "paid_price",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("SalonProvider.tax"),
          value: "tax_value",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("SalonProvider.total_with_tax"),
          value: "total_with_tax",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.package_duration"),
          value: "package_duration",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("SalonProvider.sub-created_at"),
          value: "subscription_date",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("SalonProvider.end_at"),
          value: "expiry_date",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("SalonProvider.subscription-status"),
          value: "subscription_status",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Admins.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      pdf: null,

      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data
    };
  },

  // watch: {
  //   // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
  //   ["$route.query.page"]() {
  //     this.paginations.current_page = +this.$route.query.page;
  //     this.setTableRows();
  //   },
  //   // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  // },
  // watch: {
  //   // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
  //   ["$route.query.page"]() {
  //     this.paginations.current_page = +this.$route.query.page;
  //     this.setTableRows();
  //   },
  //   // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  // },

  methods: {
    async downloadPdf(item) {
      window.open(item.pdf, "_blank");
    },
    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemImage = item.package_image;
      this.selectedItemType = "image";
    },
    async setTableRows() {
      this.loading = true;
      try {
        const { from, to } = this.$route.query;
        console.log(this.$route.query);

        let res = await this.$axios({
          method: "GET",
          url: `providers/subscriptions/${this.$route.params.id}`,
          params: {
            page: this.paginations.current_page,
            from: from,
            to: to,
          },
          params: {
            page: this.paginations.current_page,
            from: from,
            to: to,
          },
        });
        // console.log(res.data.data.data);

        this.loading = false;
        this.tableRows = res.data.data.data;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();

    // End:: Fire Methods
  },
};
</script>
<style scoped>
.text-success-sub span {
  color: green !important;
}
</style>
